import React, { createContext, useState } from "react";

const SideNavContext = createContext({
    sideNavOpen: false,
    handleSideNavUpdate: () => {},
    fullscreenMode: false,
    handleFullscreenModeUpdate: () => {},
});

export const SideNavProvider = ({ children }) => {
    const [navOpen, setNavOpen] = useState(false);
    const [fullscreenMode, setFullscreenMode] = useState(false);

    const handleSideNavUpdate = status => {
        setNavOpen(status);
    };

    const handleFullscreenModeUpdate = status => {
        setFullscreenMode(status);
    };

    return (
        <>
            <SideNavContext.Provider
                value={{
                    navOpen,
                    handleSideNavUpdate,
                    fullscreenMode,
                    handleFullscreenModeUpdate,
                }}
            >
                {children}
            </SideNavContext.Provider>
        </>
    );
};

export default SideNavContext;
